// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___3r0D-","m-signature-pad--body":"styles__m-signature-pad--body___3UvRf","m-signature-pad--footer":"styles__m-signature-pad--footer___1nxX1","description":"styles__description___i2Kio","button":"styles__button___YCaky","clear":"styles__clear___2Vm8f","save":"styles__save___3Pe-K","m-signature-pad":"styles__m-signature-pad___390Q_","github":"styles__github___3XCtS","breakLine":"styles__breakLine___2e-vq"};


//////////////////
// WEBPACK FOOTER
// ./client/app/shared/components/BreakLine/styles.scss
// module id = MjB7
// module chunks = client